import { observer } from "mobx-react-lite";
import {
  ItemListSkeletonRowData,
  ItemListRowType,
  ItemListAsyncSessionRowData,
} from "@/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { ItemListSkeletonRow } from "./item-list-skeleton-row";
import { ItemListItemRow } from "./item-list-item-row";

export interface ItemListAsyncSessionRowProps {
  data: ItemListAsyncSessionRowData;
}

export const ItemListAsyncSessionRow: FC<ItemListAsyncSessionRowProps> = observer(({ data }) => {
  const { store } = useAppStore();
  const session = store.sessions.get(data.payload.sessionId);

  const skeletonRowData: ItemListSkeletonRowData = {
    key: data.key,
    type: ItemListRowType.Skeleton,
    payload: {},
  };

  if (!session) return <ItemListSkeletonRow data={skeletonRowData} />;

  const itemRowData =
    typeof data.payload.itemRow === "function"
      ? data.payload.itemRow(session)
      : data.payload.itemRow;

  return <ItemListItemRow data={itemRowData} />;
});
